var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c(
        "div",
        { staticClass: "app-header" },
        [
          _c(
            "el-form",
            {
              ref: "query",
              attrs: { model: _vm.query, size: "mini", inline: true },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "优惠名称：", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入优惠名称", clearable: "" },
                    model: {
                      value: _vm.query.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "name", $$v)
                      },
                      expression: "query.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "发放账号：", prop: "phone" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "179px" },
                    attrs: { placeholder: "请输入发放账号" },
                    model: {
                      value: _vm.query.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "phone", $$v)
                      },
                      expression: "query.phone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态：", prop: "state" } },
                [
                  _c("avue-select", {
                    attrs: {
                      placeholder: "请选择状态",
                      dic: [
                        { label: "待审核", value: 1 },
                        { label: "已发放", value: 2 },
                        { label: "未通过", value: 3 },
                        { label: "发放失败", value: 4 },
                        { label: "发放中", value: 5 },
                      ],
                    },
                    model: {
                      value: _vm.query.state,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "state", $$v)
                      },
                      expression: "query.state",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "发券时间：", prop: "dateArr" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      format: "yyyy-MM-dd",
                      valueFormat: "yyyy-MM-dd",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                    },
                    on: { change: _vm.handelDateArr },
                    model: {
                      value: _vm.query.dateArr,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "dateArr", $$v)
                      },
                      expression: "query.dateArr",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "发券人：", prop: "createUser" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "179px" },
                    attrs: { placeholder: "请输入发券人" },
                    model: {
                      value: _vm.query.phoneOrName,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "phoneOrName", $$v)
                      },
                      expression: "query.phoneOrName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "隶属公司：", prop: "merchantIds" } },
                [
                  _c("YdMerchantSelector", {
                    attrs: {
                      multiple: "",
                      placeholder: "请选择隶属公司",
                      styles: "width: 179px",
                    },
                    model: {
                      value: _vm.query.merchantIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "merchantIds", $$v)
                      },
                      expression: "query.merchantIds",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-search",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.searchChange },
                    },
                    [_vm._v("\n          筛选\n        ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        icon: "el-icon-delete",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.searchReset },
                    },
                    [_vm._v("\n          清空\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "crud__container" },
        [
          _c(
            "yd-table",
            {
              ref: "crud",
              attrs: {
                columns: _vm.option.column,
                loading: _vm.loading,
                data: _vm.data,
                pagination: _vm.page,
                size: "mini",
              },
              on: { onChange: _vm.onTableChange },
              scopedSlots: _vm._u([
                {
                  key: "name",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.rowDetails(row.id)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(row.name) + "\n        "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "account",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("span", [_vm._v(_vm._s(row.accountNum) + " 个")]),
                    ]
                  },
                },
                {
                  key: "menu",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      row.state === 2
                        ? _c("span", [_vm._v("-")])
                        : _c(
                            "span",
                            [
                              row.state === 1
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "mini" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.handleAudit(row.id)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "has-permi",
                                              rawName: "v-has-permi",
                                              value: [
                                                "distCountCoupon_send_examine",
                                              ],
                                              expression:
                                                "['distCountCoupon_send_examine']",
                                            },
                                          ],
                                          attrs: { type: "text", size: "mini" },
                                        },
                                        [
                                          _vm._v(
                                            "\n              通过\n            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              row.state === 1
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "mini" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.handleAuditReason(row.id)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "has-permi",
                                              rawName: "v-has-permi",
                                              value: [
                                                "distCountCoupon_send_examine",
                                              ],
                                              expression:
                                                "['distCountCoupon_send_examine']",
                                            },
                                          ],
                                          attrs: { type: "text", size: "mini" },
                                        },
                                        [
                                          _vm._v(
                                            "\n              不通过\n            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              row.state === 3
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "mini" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.handleQueryReason(row.id)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            查看原因\n          "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "tools" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["distCountCoupon_send_give"],
                          expression: "['distCountCoupon_send_give']",
                        },
                      ],
                      attrs: {
                        type: "primary",
                        size: "mini",
                        icon: "el-icon-circle-plus-outline",
                      },
                      on: { click: _vm.handleAddOrUpdate },
                    },
                    [_vm._v("\n          发放优惠券\n        ")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _vm.sendCouponAddVisible
        ? _c("send-coupon-add", {
            ref: "sendCouponAdd",
            on: { refreshDataList: _vm.onLoad },
          })
        : _vm._e(),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "发放详情",
            visible: _vm.visibile,
            "append-to-body": true,
            size: "45%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visibile = $event
            },
            close: _vm.closeDetial,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "title-box",
              attrs: { slot: "title" },
              slot: "title",
            },
            [_vm._v("发放详情")]
          ),
          _c(
            "div",
            { staticStyle: { "padding-left": "10px" } },
            [
              _c(
                "el-descriptions",
                { attrs: { column: "1" } },
                [
                  _c("el-descriptions-item", { attrs: { label: "状态" } }, [
                    _vm._v(_vm._s(_vm.info.statesTr)),
                  ]),
                  _vm.info.state === 3
                    ? _c(
                        "el-descriptions-item",
                        { attrs: { label: "不通过原因" } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.info.refusedReason) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        label: "发放用户",
                        contentStyle: { maxHeight: "200px", overflow: "auto" },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.info.phones ? _vm.info.phones.join(",") : ""
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions",
                { attrs: { column: "1", direction: "vertical" } },
                [
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "优惠券" } },
                    [
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.info.couponDetailVos,
                            border: "",
                            size: "mini",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "优惠券名称",
                              prop: "name",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "优惠类型",
                              prop: "type",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.type === 1
                                            ? "礼包"
                                            : "优惠券"
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "金额/个",
                              prop: "amount",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "剩余",
                              prop: "surplusNum",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "发放数量",
                              prop: "num",
                              align: "center",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions",
                { attrs: { column: "1" } },
                [
                  _c("el-descriptions-item", { attrs: { label: "通知方式" } }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.info.notification || "-") +
                        "\n        "
                    ),
                  ]),
                  _vm.info.imgUrl
                    ? _c(
                        "el-descriptions-item",
                        { attrs: { label: "通知弹窗" } },
                        [
                          _c("img", {
                            staticStyle: { width: "160px", height: "180px" },
                            attrs: { src: _vm.info.imgUrl },
                          }),
                        ]
                      )
                    : _c(
                        "el-descriptions-item",
                        { attrs: { label: "通知弹窗" } },
                        [_vm._v("-")]
                      ),
                  _c("el-descriptions-item", { attrs: { label: "发券原因" } }, [
                    _vm._v(_vm._s(_vm.info.remark)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "发券人" } }, [
                    _vm._v(_vm._s(_vm.info.createUserName)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "发券时间" } }, [
                    _vm._v(_vm._s(_vm.info.createTime)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "审核人" } }, [
                    _vm._v(_vm._s(_vm.info.auditorName || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "审核时间" } }, [
                    _vm._v(_vm._s(_vm.info.auditTime || "-")),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.nInfo.type === "N" ? "审核不通过" : "查看原因",
            visible: _vm.nVisible,
            width: "55%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.nVisible = $event
            },
          },
        },
        [
          _vm.nInfo.type === "N"
            ? _c(
                "div",
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        model: _vm.nInfo,
                        size: "small",
                        "label-width": "99px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "不通过的原因" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入不通过原因",
                            },
                            model: {
                              value: _vm.nInfo.refusedReason,
                              callback: function ($$v) {
                                _vm.$set(_vm.nInfo, "refusedReason", $$v)
                              },
                              expression: "nInfo.refusedReason",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "info" },
                              on: {
                                click: function ($event) {
                                  _vm.nVisible = !_vm.nVisible
                                },
                              },
                            },
                            [_vm._v("取消")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSubmit },
                            },
                            [_vm._v("提交")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.nInfo.type === "ND"
            ? _c(
                "div",
                [
                  _c(
                    "el-form",
                    [
                      _c("el-form-item", { attrs: { label: "状态:" } }, [
                        _vm._v(
                          _vm._s(_vm.ndInfo.state === 3 ? "审核未通过" : "")
                        ),
                      ]),
                      _c("el-form-item", { attrs: { label: "不通过原因:" } }, [
                        _vm._v(_vm._s(_vm.ndInfo.refusedReason)),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }